import typeCheckUtils from '../utils/typeCheckUtils';

const RentersInsurance = ({
  isEligibleForIsRentersInsuranceRequiredQuestion = false,
  isRentersInsuranceRequired = null,
} = {}) => ({
  isEligibleForIsRentersInsuranceRequiredQuestion: Boolean(isEligibleForIsRentersInsuranceRequiredQuestion),
  isRentersInsuranceRequired: typeCheckUtils.Boolean(isRentersInsuranceRequired),
});

export type RentersInsuranceProps = ReturnType<typeof RentersInsurance>;

export default RentersInsurance;
